import { runtimeEnv } from 'config/runtimeEnv';
// src/services/InvoiceTaxService.js
import requestInstance from './Request';

const env = runtimeEnv('B2B_API_BASE_URL');

const InvoiceTaxService = {
  // GET /trip-api/v1/b2b-invoices?tripId=<tripId>
  async getInvoiceTaxes(tripId, type = 'private', magicToken = '') {
    try {
      let url;
      if (type === 'public' && magicToken) {
        url = `${env}/trip-api/v1/b2b-invoices?magicToken=${magicToken}`;
      } else {
        url = `${env}/trip-api/v1/b2b-invoices?tripId=${tripId}`;
      }
      const response = await requestInstance.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching invoice taxes:', error);
      throw error;
    }
  },

  // PATCH /trip-api/v1/b2b-invoices/:tripId/taxes
  async updateInvoiceTaxes(tripId, payload) {
    try {
      const response = await requestInstance.patch(
        `${env}/trip-api/v1/b2b-invoices/${tripId}/taxes`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error('Error updating invoice taxes:', error);
      throw error;
    }
  },
};

export default InvoiceTaxService;
